module.exports = __webpack_public_path__ + "static/new-hc-img-0dcac13fadc32daf059c9937109dfaa9.png";